interface Facet {
    el: HTMLElement;
    isActive: boolean;
    amount: number;
}

window.Drupal.behaviors['searchFacets'] = {
    attach(context: HTMLElement | Document): void {
        activateFirstFacetWithResultsIfNoneActive(document);
    },
};

let FILTERS_INITIALIZED = false;

function activateFirstFacetWithResultsIfNoneActive(context: HTMLElement | Document): void {
    if (FILTERS_INITIALIZED) return;

    const filters = getFacets(context);
    FILTERS_INITIALIZED = filters.length > 0;

    const active = getActiveFacet(filters);
    if (filters.length > 0 && (!active || active.amount === 0)) {
        const filter = firstWithResults(filters);
        if (filter) activateFacet(filter);
    }
}

function getFacets(context: HTMLElement | Document): Facet[] {
    const elements = context.querySelectorAll<HTMLElement>('[data-custom-search-facet]');
    return Array.from(elements).map((el) => {
        return {
            el,
            isActive: el.dataset['customSearchFacetActive'] === 'true',
            amount: parseInt(el.dataset['customSearchFacetAmount'] || ''),
        } as Facet;
    });
}

function getActiveFacet(filters: Facet[]): Facet | null {
    return filters.find((f) => f.isActive) || null;
}

function firstWithResults(filters: Facet[]): Facet | null {
    return filters.find((filter) => filter.amount > 0) || null;
}

function activateFacet(filter: Facet): void {
    filter.el.querySelector('a')?.click();
}
